/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

export default function testErorrStack() {
  // If source maps are applied, this Error will have a stack frame with line 12.
  throw Error('Test Error stack');
}

export const SOURCE_STACK_FRAME_LINE_NUMBER = 12;